import React from "react";
import { Layout, MatchingLevelIncome } from "../components";
import "../assets/css/main.css";

const MatchingIncomePage = () => {
  return (
    <>
      <Layout>
        <MatchingLevelIncome />
      </Layout>
    </>
  );
};

export default MatchingIncomePage;
